export const stateToParamsMapping = {
  search: {
    menu_param: "search",
    filter_param: "search",
  },
  product_type_id: {
    menu_param: "type",
    filter_param: "t",
  },
  category_id: {
    menu_param: "category",
    filter_param: "c",
  },
  subcategory_id: {
    menu_param: "subcategory",
    filter_param: "s",
  },
  distributor_ids: {
    menu_param: "distributors",
    filter_param: "d",
    transform: p => (Array.isArray(p) ? p : [p]),
  },
  container_type: {
    menu_param: "container",
    filter_param: "n",
  },
  brand_family_id: {
    menu_param: "brandFamilyId",
    filter_param: "b",
  },
  manufacturer_id: {
    menu_param: "manufacturerId",
    filter_param: "m",
  },
  vintage_year: {
    filter_param: "v",
  },
  appellation_id: {
    menu_param: "appellation",
    filter_param: "ap",
  },
  country_id: {
    menu_param: "country",
    filter_param: "co",
  },
  region_id: {
    menu_param: "region",
    filter_param: "re",
  },
  material: {
    filter_param: "r",
  },
  raw_material_id: {
    menu_param: "rawMaterial",
    filter_param: "rm",
  },
  container_size: {
    filter_param: "z",
  },
  has_discounts: {
    filter_param: "dl",
  },
  previously_ordered: {
    filter_param: "po",
  },
  my_distributors: {
    filter_param: "md",
  },
  tag_id: {
    filter_param: "fe",
    menu_param: "tagId",
  },
  tag_search: {
    filter_param: "tagSearch",
  },
  distributor_search: {
    filter_param: "distributorSearch",
  },
  material_search: {
    filter_param: "materialSearch",
  },
  product_type_search: {
    filter_param: "productTypeSearch",
  },
  category_search: {
    filter_param: "categorySearch",
  },
  subcategory_search: {
    filter_param: "subcategorySearch",
  },
  brand_family_search: {
    filter_param: "brandFamilySearch",
  },
  manufacturer_search: {
    filter_param: "manufacturerSearch",
  },
  appellation_search: {
    filter_param: "appellationSearch",
  },
  country_search: {
    filter_param: "countrySearch",
  },
  region_search: {
    filter_param: "regionSearch",
  },
  container_size_search: {
    filter_param: "container_sizeSearch",
  },
  raw_material_search: {
    filter_param: "rawMaterialSearch",
  },
  sale_division_search: {
    filter_param: "saleDivisionSearch",
  },
  container_type_search: {
    filter_param: "container_typeSearch",
  },
  product_sort: {
    filter_param: "product_sort",
  },
  in_stock: {
    filter_param: "ins",
  },
  future_pricing: {
    filter_param: "fp",
  },
  frontline_price: {
    filter_param: "f",
  },
  suggestion_type: {
    filter_param: "st",
  },
  suggestion_id: {
    filter_param: "si",
  },
  sale_division_id: {
    filter_param: "sd",
    transform: p => (Array.isArray(p) ? p : [p]),
  },
  abv: {
    filter_param: "abv",
  },
};

const getFilterParamsFromState = stateParams => {
  let params = {};
  for (const [key, filter_definition] of Object.entries(stateToParamsMapping)) {
    const menuParam = filter_definition.menu_param;
    const filterParam = filter_definition.filter_param;
    let value;
    if (
      menuParam &&
      stateParams[menuParam] &&
      (Array.isArray(stateParams[menuParam]) ? stateParams[menuParam].length > 0 : true)
    ) {
      value = stateParams[menuParam];
    } else if (filterParam && stateParams[filterParam]) {
      value = stateParams[filterParam];
    }
    if (value === "undefined" || value === "null") {
      value = null;
    }
    if (value) {
      if (filter_definition.transform !== undefined) {
        params[key] = filter_definition.transform(value);
      } else {
        params[key] = value;
      }
    } else if (params[key]) {
      delete params[key];
    }
  }

  if (stateParams.fired_filter != null) {
    params.fired_filter = stateParams.fired_filter;
  }

  return params;
};

export default getFilterParamsFromState;
